import type { QueryClient } from "@tanstack/react-query";

export const NotificationsKeys = {
	all: ["notifications"] as const,
	count: () => [...NotificationsKeys.all, "count"] as const,
	infiniteGroupedList: (unreadOnly?: boolean) =>
		[
			...NotificationsKeys.all,
			"grouped",
			"list",
			"infinite",
			{ unreadOnly },
		] as const,
};

export const invalidateNotifications = (queryClient: QueryClient) =>
	queryClient.invalidateQueries({ queryKey: NotificationsKeys.all });
